import classNames from 'classnames'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { EffectFade } from 'swiper'
import { useEffect, useMemo, useState } from 'react'
import 'swiper/css'
import 'swiper/css/effect-fade'
import { MyImage } from '~/components/ui/MyImage'
import styles from './DraftArtworkImages.module.css'

interface IProps {
  images: { url: string | null; key: number }[]
}

const DraftArtworkImages: React.FC<IProps> = ({ images }) => {
  return (
    <div className="w-full h-full mx-auto overflow-hidden">
      <Swiper
        className={classNames(styles.swiper, '')}
        effect={'coverflow'}
        modules={[EffectFade]}
        loop={true}
        allowTouchMove={false}
        fadeEffect={{ crossFade: true }}
      >
        {images.map(it => {
          return (
            <SwiperSlide key={it.key}>
              <div className="w-full h-[809px]">
                <MyImage
                  src={it.url!}
                  alt=""
                  objectFit="contain"
                  className="w-full h-full"
                />
              </div>
            </SwiperSlide>
          )
        })}
        {images.length > 1 && <Pagination images={images} />}
      </Swiper>
    </div>
  )
}

const Pagination: React.FC<IProps> = ({ images }) => {
  const swiper = useSwiper()
  const [idx, setIdx] = useState(swiper.realIndex)

  useEffect(() => {
    const handler = (s: any) => {
      setIdx(s.realIndex)
    }
    swiper.on('realIndexChange', handler)
    return () => swiper.off('realIndexChange', handler)
  }, [])

  const active = useMemo(() => {
    return images[swiper.realIndex]
  }, [idx, images])

  const handleClick = (select: any) => {
    swiper.slideToLoop(
      images.findIndex(it => it.key === select.key),
      0
    )
  }

  return (
    <div
      className="absolute bottom-6 left-0 right-0 z-50 w-full flex justify-center gap-4"
      onClick={e => {
        e.stopPropagation()
      }}
    >
      {images.map(it => {
        return (
          <div
            key={it.key}
            className={classNames(
              'w-[80px] h-[80px] border-2 border-transparent rounded-lg',
              {
                '!border-neutral-900': active === it,
              }
            )}
            onClick={() => {
              handleClick(it)
            }}
          >
            <img
              src={it.url!}
              className="w-full h-full rounded-lg object-cover"
              alt=""
            />
          </div>
        )
      })}
    </div>
  )
}

export default DraftArtworkImages
